<template>
  <div>
    <Loader :loading="loading"/>
    <router-view v-if="initialized"/>
    <div class="snackbar snackbar-boxed">
      <p class="bg-red-light" id="errorSnack"><i class="fa fa-warning"></i><span id="errorMessage"> Error </span><a href="javascript:;"><i class="fa fa-close"></i></a></p>
      <p class="bg-green-dark" id="successSnack"><i class="fa fa-check"></i> <span id="successMessage"> Success </span> <a href="javascript:;"><i class="fa fa-close"></i></a></p>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import '../styles/font.css'
import '../styles/framework.css'
import '../styles/style.css'
import Loader from './components/Loader'
import {mapState, mapActions} from 'vuex'
export default {
  name: 'App',
  components: {
    Loader
  },
  mounted () {
    this.mount()
  },
  computed: {
    ...mapState(['initialized', 'route', 'loading'])
  },
  methods: {
    ...mapActions(['fetchPosts', 'login']),
    mount () {
      if (this.route && !this.isEmpty(this.route.query)) {
        if (!this.initialized) {
          this.initialize()
        }
      }
    },
    initialize () {
      // Login Callback Endpoints - Initialize without login
      if ((this.route.name === 'Login' && (this.route.query.code || this.route.query.oauth || this.route.params.oauth)) || this.route.name === 'Terms' || this.route.name === 'FacebookSuccess' || this.route.name === 'Company') {
        // Company - SMS Review Link
        if (this.$route.query && this.$route.query.token) {
          this.$store.commit('setToken', this.$route.query.token)
        }
        this.$store.commit('setLoading', false)
        return this.$store.commit('setInitialize', true)
      }

      if (this.route.query.mode === 'gift') {
        return this.login({
          mode: 'gift',
          CompanyId: this.route.query.companyId,
          scanKey: this.route.query.key
        }).then(() => this.fetchPosts())
          .then(() => this.$store.commit('setLoading', false))
      }

      // Check id and ap parameters if valid mac address
      if (this.route && !this.isEmpty(this.route.query) && this.formatAndCheckParams()) return

      // WiFi Mode Login
      this.login()
        .then(() => this.fetchPosts())
        .then(() => this.$store.commit('setLoading', false))
    }
  },
  watch: {
    'route.name' (nv) {
      this.mount()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue